<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>对账单列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box">
        <div class="list-box">
          <div class="r-list">
            <div class="search-box">
              <el-select
                :disabled="companyDis"
                v-model="companyId"
                filterable
                placeholder="请选择公司"
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-date-picker
                v-model="gmtCreate"
                type="month"
                placeholder="时间月份"
                :picker-options="pickerOptions"
                format="yyyy-MM"
                value-format="yyyy-MM"
              >
              </el-date-picker>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="initData"
              ></el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
            @selection-change="handleSelectionChange"
          >
            <el-table-column width="15"></el-table-column>
            <el-table-column label="客户名称" width="150">
              <template slot-scope="scope">
                <h4>{{ scope.row.companyName }}</h4>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="月份"></el-table-column>
            <el-table-column
              prop="totalChargePower"
              label="充电量"
            ></el-table-column>
            <el-table-column
              prop="totalDischargePower"
              label="放电量"
            ></el-table-column>
            <el-table-column prop="totalProfit" label="收益"></el-table-column>
            <el-table-column prop="status" label="是否确认" align="center">
              <template slot-scope="scope">
                <el-tag
                  size="small"
                  type="warning"
                  effect="dark"
                  v-if="scope.row.state == 0"
                  >未确认</el-tag
                >
                <el-tag
                  size="small"
                  type="success"
                  effect="dark"
                  v-else-if="scope.row.state == 1"
                  >已确认</el-tag
                >
                <el-tag size="small" type="info" effect="dark" v-else
                  >其它</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" align="right">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  v-if="scope.row.state != 0"
                  @click="linkUrl(scope.row)"
                  >查看</el-button
                >
                <el-button
                  size="mini"
                  v-if="scope.row.state == 0"
                  @click="linkUrl(scope.row)"
                  >去确认</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax } from "../../js/axios.config";
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      loading: false,
      companyList: [],
      companyId: "",
      gmtCreate: "",
      keyword: "",
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
      companyDis: false,
    };
  },
  mounted() {
    //获取公司
    const _this = this;
    if (localStorage.getItem("fx_login_companyType") != 0) {
      _this.companyList = [
        {
          id: localStorage.getItem("fx_login_companyId"),
          companyName: localStorage.getItem("fx_login_company"),
        },
      ];
      _this.companyId = localStorage.getItem("fx_login_companyId");
      _this.companyDis = true;
    } else {
      AxiosAjax({
        url: "/cabinet/company/search",
        success: function (res) {
          _this.companyList = res.data.data;
        },
      });
    }
  },
  methods: {
    //加载数据
    initData: function () {
      let _this = this;
      // companyId gmtCreate
      let sendUrl = "/cabinet/chargeStatement/page";
      sendUrl += "?size=" + _this.pageSize;
      sendUrl += "&index=" + _this.pageIndex;
      if (_this.companyId) {
        sendUrl += "&companyId=" + _this.companyId;
      }
      if (_this.gmtCreate) {
        sendUrl += "&gmtCreate=" + _this.gmtCreate;
      }
      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data.content;
          _this.totalCount = res.data.data.total;
          _this.pageIndex = res.data.data.index;
        },
        error: function (err) {
          _this.listData = null;
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    //跳转链接
    linkUrl: function (url) {
      this.$router.push({
        name: "ReconciliationEdit",
        query: { id: url.companyId, gmtCreate: url.date },
      });
    },
    //选中第几行
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
      //console.log('每页 ${val} 条');
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
      //console.log('当前页: ${val}');
    },
  },
  created: function () {
    //加载数据
    this.initData();
  },
};
</script>
<style scoped>
.toolbar-box .list-box {
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Reconciliation/ReconciliationList.vue